import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {withSafeArea} from '/provider/SafeAreaProvider';
import {searchResultsSizeBySearchInput} from '/redux/selector/search.selector';
import {withHOC} from '/util/hoc.util';

import {Filter} from './Filter';

export const FilterConnected = withHOC(
  connect(
    createStructuredSelector({
      searchResultsSize: searchResultsSizeBySearchInput,
    }),
  ),
  withSafeArea,
)(Filter);
